module.exports = false;



//////////////////
// WEBPACK FOOTER
// /Users/kevinelshout/Webroot/bulkmanager/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 1